export const getCookie = (cname: string) => {
  if (typeof window !== "undefined") {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return "";
};

export const getAllCookies = () =>{
  if (typeof window !== "undefined") {
    // let name = cname + "=";
    let cookieObj:any = {};
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      const name = ca[i].substring(0, ca[i].indexOf("="));
      const str = ca[i].substring(ca[i].indexOf("=")+1,ca[i]?.length);
      const index = str.substring(0,str.length);
      cookieObj[name?.trim() ?? "Unknown"] = index;
    }
    
    return cookieObj;
  }
  return {};
}

export const setCookie = (cname: string, cvalue: any, exdays?: number) => {
  if (typeof window !== "undefined") {
    const d = new Date();
    d.setTime(d.getTime() + (exdays ?? 60) * 24 * 60 * 60 * 1000);
    let expires = "Expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
  }
};

export const deleteCookie = (cname:string) =>{
  if (typeof window !== "undefined") {
    document.cookie = cname +'=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}
export const clearAllCookies = () =>{
  if (typeof window !== "undefined") {
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
    });
  }
}